import { combineReducers } from 'redux'

import activity from './Activity/activity.reducer'
import battles from './Battles/battles.reducer'
import colonySettings from './Phases/Phase0Screen/phase0.reducer'
import documents from './Documents/documents.reducer'
import events from './Events/events.reducer'
import indicators from './Indicators/indicators.reducer'
import pointsManager from './PointsManager/pointsManager.reducer'
import map from './Map/map.reducer'
import mining from './Mining/mining.reducer'
import phases from './Phases/phases.reducer'
import profile from './Profile/profile.reducer'
import quizzes from './Quizzes/quizzes.reducer'
import ranking from './Ranking/ranking.reducer'
import resumes from './Resumes/resumes.reducer'
import survey from './Survey/survey.reducer'
import settings from './Settings/settings.reducer'
import toast from './Toast/toast.reducer'
import endGame from './Phases/EndGameScreen/endgame.reducer'

export default combineReducers({
  // Here come the reducers of each module
  activity,
  battles,
  colonySettings,
  documents,
  events,
  indicators,
  map,
  endGame,
  mining,
  phases,
  profile,
  quizzes,
  ranking,
  resumes,
  settings,
  survey,
  pointsManager,
  toast,
})
